module.exports = __webpack_public_path__ + "static/media/clutch2.9938ed0f.svg";